import { CoverBadge } from './CoverBadge'
import { withCoverBadge } from './withCoverBadge'

const ConnectedCoverBadge = withCoverBadge(CoverBadge)

export { ConnectedCoverBadge as CoverBadge }
